import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { matchSorter } from 'match-sorter';
import TextField from '@/components/form/TextField/TextField';
import { FilterContainer, FilterResult } from './FilterHoneyMoonList.styles';
import SelectField from '@/components/form/SelectField/SelectField';
import { sanitizeQueryParams } from '@/helpers/sanitize';
import { useTranslations } from 'next-intl';

type FilterListType = PacoteHoneyMoonListType;

export interface FilterHoneyMoonListProps<T> {
  initialData: FilterListType[];
  listDestinos: ListDestinosType[];
  children: ({ data }: { data: FilterListType[] }) => ReactNode;
}

const FilterHoneyMoonList = <T,>({ initialData, listDestinos, children }: FilterHoneyMoonListProps<T>) => {
  const t = useTranslations('Viagem');
  const inputRef = useRef<HTMLInputElement>(null);
  const [data, setData] = useState<FilterListType[]>(initialData);
  const { query, ...router } = useRouter();

  const resultsCounter = (filtered: FilterListType[]) => {
    let total = 0;
    filtered.map((item) => {
      item.pacotes.forEach((pacote) => {
        total++;
      });
    });
    return total;
  };

  const handleFilter = (event: React.ChangeEvent<HTMLInputElement>): void => {
    event.preventDefault();
    const value = event.target.value;

    if (value.trim().length === 0) {
      setData((prevState) => initialData);
    } else {
      const filtered: FilterListType[] = [];
      data.forEach((item) => {
        let found = matchSorter(item.pacotes, value, {
          keepDiacritics: true,
          keys: ['title', 'slug', 'travel_cities'],
        });
        if (found.length) {
          filtered.push({
            continent: item.continent,
            pacotes: found,
          });
        }
      });

      setData((prevState) => filtered);
    }
  };

  const resetFilter = (): void => {
    if (inputRef.current?.value) {
      inputRef.current.value = '';
      setData(() => initialData);
    }
  };

  const handleFilterDestino = (event: React.ChangeEvent<HTMLSelectElement>) => {
    router.push(`?filter=${event.target.value}`, undefined, { shallow: false });
  };

  useEffect(() => {
    setData((prevState) => [...initialData]);
  }, [initialData]);

  return (
    <>
      <FilterContainer>
        <form onSubmit={(e) => e.preventDefault()}>
          <TextField
            ref={inputRef}
            type="text"
            placeholder={t('Buscar Roteiros em Lua de Mel')}
            name="filter"
            onChange={handleFilter}
            bgIcon="search"
          />
          <SelectField
            name="filter"
            placeholder={t('Filtrar por destino')}
            value={sanitizeQueryParams(query.filter) || ''}
            onChange={handleFilterDestino}
          >
            <option value="">{t('Filtrar por destino')}</option>
            {listDestinos?.map(({ title, value, selected }, index) => (
              <option value={value} key={`${index}-${value}`}>
                {title}
              </option>
            ))}
          </SelectField>
        </form>
      </FilterContainer>
      <FilterResult fade={!!inputRef.current?.value}>
        <span>
          <strong>{resultsCounter(data)}</strong> ite{data.length > 1 ? t('ns') : `m`} {t('encontrado(s)')}
        </span>
        <span>
          <button onClick={resetFilter}>{t('limpar filtro')}</button>
        </span>
      </FilterResult>
      {children({ data })}
    </>
  );
};

export default FilterHoneyMoonList;
